import { writable } from 'svelte/store';

const Store = () => {
	const { subscribe, set } = writable(false);

	// 作成
	const loadStart = () => {
		set(true);
	};

	const loadEnd = () => {
		set(false);
	};

	return { subscribe, loadStart, loadEnd };
};

export const loadingStore = Store();
